import React, { useEffect } from "react";
import {
  Button,
  Radio,
  FormControlLabel,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import address_edit from "../../User/assets/icons/address-edit.svg";
import { useNavigate } from "react-router-dom";

const Default_address = ({
  data,
  selectedId,
  onSelect,
  setCurrentStep,
  handleOrder,
  selectedData,
}) => {
  const navigate = useNavigate();
  const location = window.location.pathname;
  const paramIds = selectedData?.map((pid) => pid.design_id._id)



  useEffect(() => {
    if (data?.default && !selectedId) {
      onSelect(data);
    }
  }, [data, selectedId]);
  return (
    <>
      <div className="address_info_box">

        <div className="address_header">
          <div className="default-address">
            {location === "/mycart" && (
              <FormControlLabel
                control={
                  <Radio
                    checked={selectedId?._id === data?._id}
                    onChange={() => onSelect(data)}
                    sx={{
                      color: "#E37B00",
                      "&.Mui-checked": {
                        color: "#E37B00",
                      },
                    }}
                  />
                }
              />
            )}
            <Typography variant="h5">{data?.name}</Typography>
            {data?.default === true ? <Button>Default</Button> : null}
          </div>

          {location === "/profile/address" && (
            <div className="Edit_address_button">
              <Button
                onClick={() => navigate(`/profile/addadress/${data?._id}`)}
              >
                Edit
                <img src={address_edit} alt="address_edit" />{" "}
              </Button>
            </div>
          )}
        </div>


        <div className="add-address">
          <List>
            <Typography variant="h5">Address:</Typography>
            <ListItem>
              {data?.line_1}, {data?.line_2}, {data?.landmark}, {data?.city},{" "}
              {data?.state}, {data?.pincode}.
            </ListItem>
            <Typography variant="h5">Mobile number:</Typography>
            <ListItem>{data?.mobile}</ListItem>
          </List>
        </div>

        {selectedId?._id === data?._id && location === "/mycart" ? (
          <div className="catalogue-delivery-btn">
            <Button
              className="edit-btn"
              onClick={() =>
                navigate(`/profile/addadress/${selectedId?._id}`)
              }
            >
              Edit
            </Button>
            <Button
              className="confirm-btn"
              onClick={() => {
                setCurrentStep(2);
                handleOrder();
              }}
            >
              Confirm
            </Button>
          </div>
        ) : null}

      </div>

    </>
  );
};

export default Default_address;
